"use strict";
export const fileHelper={
  generateGpx,
  generateKML
}

function generateGpx(dataObj) {
  const header = '<?xml version="1.0" encoding="UTF-8"?>'
  const gpxHeader = '<gpx creator="PRAMES S.A." xmlns="http://www.topografix.com/GPX/1/1" ' +
    'xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.topografix.com/GPX/1/1 ' +
    'http://www.topografix.com/GPX/1/1/gpx.xsd" version="1.1"><metadata/>'
  const gpxClose = '</gpx>'
  let nodes = ''
  let lines = ''
  //Primero los nodos
  dataObj.points.forEach((n) => {
    nodes += `<wpt lat="${n.coords.lat}" lon="${n.coords.lon}"><name>${n.name}</name></wpt>`
  })

  //Los Tracks
  dataObj.lines.forEach((li) => {
    lines += `<trk><name>${li.name}</name><trkseg>`
    li.coords.forEach((c)=>{
      lines += `<trkpt lat="${c.lat}" lon="${c.lon}"></trkpt>`
    })
    lines += `</trkseg></trk>`
  })
  return `${header}${gpxHeader}${nodes}${lines}${gpxClose}`
}

function generateKML(dataObj){
  const header = '<kml xmlns="http://www.opengis.net/kml/2.2">'
  const document = '<Document>'
  const closeFile = '</Document></kml>'
  let content = ''

  //Lineas
  dataObj.lines.forEach((li) => {
    content += `<Placemark><name>${li.name}</name><LineString><coordinates>`
    li.coords.forEach((c)=>{
      content += `${c.lon},${c.lat} `
    })
    content += `</coordinates></LineString></Placemark>`
  })
  //Nodos
  dataObj.points.forEach((po) => {
    content += `<Placemark><name>${po.id}</name><description>${po.name}</description><Point><coordinates>`
    content += `${po.coords.lon},${po.coords.lat}`
    content += `</coordinates></Point></Placemark>`
  })

  return `${header}${document}${content}${closeFile}`
}



// WEBPACK FOOTER //
// ./src/_helpers/files.helper.js